import styled from "styled-components"
import { Button } from '@material-ui/core';


export const TransponderContainer = styled.div`
    display:flex;
   margin-bottom: 2px;
`

export const CleanButton = styled(Button)`
`